// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b5f3aa29","453":"7293cc9b","455":"2f0f6066","977":"1664de23"}[chunkId] + ".chunk.js";
};